"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var houston_styles_1 = require("@eduzz/houston-styles");
var TableCell = function (_a) {
    var children = _a.children, className = _a.className, props = tslib_1.__rest(_a, ["children", "className"]);
    return ((0, jsx_runtime_1.jsx)("td", tslib_1.__assign({}, props, { className: (0, houston_styles_1.cx)(className, 'hts-table-cell') }, { children: children })));
};
/**
 * @deprecated Use Table from Antd
 * https://ant.design/components/table/
 */
exports.default = TableCell;
